import commanderBg from "../assets/commander_bg.jpg";
import cantineBg from "../assets/cantine_bg.jpg";

export function Products() {
    return (
        <section id="produits" className="scroll-mt-20 py-10 px-6 bg-[#faf7f4]">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-3xl sm:text-4xl font-bold text-center text-[#1a3660] mb-4">
                    Nos <span className="text-[#f07020]">solutions</span> prêtes à l'emploi
                </h2>
                <p className="text-slate-500 text-center max-w-2xl mx-auto mb-10">
                    En plus du développement sur mesure, nous proposons deux logiciels clé en main.
                </p>

                {/* Product 1 — Resto */}
                <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden mb-10">
                    <div className="grid lg:grid-cols-2">
                        <div className="p-8 lg:p-12 flex flex-col justify-center">
                            <span className="text-sm font-semibold text-[#f07020] uppercase tracking-widest mb-3">
                                Restauration rapide
                            </span>
                            <h3 className="text-2xl sm:text-3xl font-bold text-[#1a3660] mb-2">
                                Commande en ligne pour
                                <br />
                                food trucks &amp; snacks
                            </h3>
                            <p className="text-[#f07020] font-bold text-lg mb-4">180&nbsp;€/an · 0% de commission</p>
                            <p className="text-slate-500 leading-relaxed mb-6">
                                Une application complète de commande et paiement en ligne pour les entrepreneurs
                                de la restauration rapide : camion pizza, food truck, kebab, sandwicherie.
                                Zéro commission, 180&nbsp;€/an tout inclus.
                            </p>
                            <ul className="space-y-2 text-sm text-slate-600 mb-8">
                                {[
                                    "Commande en ligne personnalisée à votre marque",
                                    "Paiement sécurisé via Stripe (CB, Apple Pay, Google Pay)",
                                    "Carte de fidélité digitale & coupons de réduction",
                                    "Notifications temps réel & alertes sonores",
                                    "Analytics, comptabilité TVA, emailing marketing",
                                    "PWA installable — opérationnel en 48h",
                                ].map((f) => (
                                    <li key={f} className="flex items-start gap-2">
                                        <span className="text-[#f07020] mt-0.5 font-bold">✓</span>
                                        {f}
                                    </li>
                                ))}
                            </ul>
                            <a
                                href="https://commander.appitep.fr"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 bg-[#f07020] hover:bg-[#d9621a] text-white font-semibold px-6 py-3 rounded-xl transition-colors w-fit shadow-md shadow-orange-200"
                            >
                                Découvrir commander.appitep.fr
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </a>
                        </div>
                        <div className="relative bg-cover bg-center min-h-[250px]" style={{ backgroundImage: `url(${commanderBg})` }}>
                            <div className="absolute inset-0 bg-black/10" />
                        </div>
                    </div>
                </div>

                {/* Product 2 — Cantine */}
                <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden">
                    <div className="grid lg:grid-cols-2">
                        <div className="relative bg-cover bg-center min-h-[250px] order-2 lg:order-1" style={{ backgroundImage: `url(${cantineBg})` }}>
                            <div className="absolute inset-0 bg-black/10" />
                        </div>
                        <div className="p-8 lg:p-12 flex flex-col justify-center order-1 lg:order-2">
                            <span className="text-sm font-semibold text-emerald-600 uppercase tracking-widest mb-3">
                                Éducation
                            </span>
                            <h3 className="text-2xl sm:text-3xl font-bold text-[#1a3660] mb-2">
                                Gestion de cantine scolaire
                            </h3>
                            <p className="text-emerald-600 font-bold text-lg mb-4">348&nbsp;€/an · soit 29&nbsp;€/mois</p>
                            <p className="text-slate-500 leading-relaxed mb-6">
                                Un logiciel complet de gestion de cantine pour les écoles primaires.
                                Inscription des enfants, gestion des repas, suivi des paiements,
                                communication avec les familles. Déjà utilisé en production
                                par l'école de Monoblet.
                            </p>
                            <ul className="space-y-2 text-sm text-slate-600 mb-8">
                                {[
                                    "Inscription et gestion des élèves",
                                    "Réservation des repas par les familles",
                                    "Paiement en ligne sécurisé par carte bancaire (Stripe)",
                                    "Suivi des paiements et facturation",
                                    "Tableau de bord pour la mairie et l'école",
                                    "Interface simple pour les parents",
                                    "Nombre illimité d'élèves — 348 €/an tout inclus",
                                ].map((f) => (
                                    <li key={f} className="flex items-start gap-2">
                                        <span className="text-emerald-500 mt-0.5 font-bold">✓</span>
                                        {f}
                                    </li>
                                ))}
                            </ul>
                            <a
                                href="https://cantine.appitep.fr"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-6 py-3 rounded-xl transition-colors w-fit shadow-md shadow-emerald-200"
                            >
                                Découvrir cantine.appitep.fr
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
